import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BillServiceModel, PartyTpa, RateType, RateList, ServiceList, BillType, SaveBillDetail, Billingconfigration } from './Models/billing.Models';
import { AuthService } from 'app/auth/auth.service';
import { DatePipe } from '@angular/common';
import { PartyDetailModel } from './Models/corporatedetail.model';



@Injectable({
  providedIn: 'root'
})
export class BillingserviceService {
  selectedServiceRow: any;
  selectedbills: any;
  getSearchPatiendId: number;
  lastbillid: number;
  public baseUrl: string;
  public newbaseUrl: string;
  public AdjustedBillingAmount: number;
  public billingSticker: any;
  patientdata: any;
  ipdDocdata: any;
  ipdID: any;
  partydetail: PartyDetailModel = {}
  //  http://20.193.244.164/WebAPIDevp/api/
  // baseUrl = "http://localhost:5101/"
  // baseUrl = "http://localhost:5101/api/"   

  billService: BillServiceModel[] = [];

  partytpa: PartyTpa[] = [];
  partytp: PartyTpa = {};
  ratetype: RateType[] = [];
  public ratelist: RateList = {};
  billtype: BillType[] = [];
  servicelist: ServiceList[] = [];
  savebilldetail: SaveBillDetail = {};
  billserviceConfig: Billingconfigration = {};
  // constructor(private http:HttpClient) { }
  selecteddate = this.datePipe.transform(this.authservice.getServerDate, "yyyy-MM-dd")
  constructor(public http: HttpClient, public authservice: AuthService, private datePipe: DatePipe,

    //public opdvisitService: OpdVisitService
  ) {


    this.baseUrl = this.authservice.baseUrl;
    this.newbaseUrl = this.authservice.newbaseUrl;


    // this.getproductionConfrigration(

  }

  get_BillService() {
    return this.http.get<any>(this.newbaseUrl + "BillSeriesMaster/GetBillSeries")
  }
  get_BillMasterService(companyId: any, BranchId: any) {
    return this.http.get<any>(this.newbaseUrl + "BillSeriesMaster/GetBillSeriesByBillingCompanyIdByBranchId/" + companyId + "/" + BranchId)
  }
  get_partytpa() {
    return this.http.get<any>(this.newbaseUrl + "PartyMaster/GetPartyAll")
  }

  get_rate_typelist() {
    return this.http.get<any>(this.newbaseUrl + "RateType/GetRateTypeList")
  }

  get_rate_list(BranchId: any, PartyId: any) {
    return this.http.get<any>(this.newbaseUrl + "RateList/GetRateList/" + BranchId + "/" + PartyId)
  }

  get_service_list(serviceId: any, RateListId: any, RateTypeId: any) {
    return this.http.get<any>(this.newbaseUrl + "RateList/GetRateListByServiceIdRateListIdRateTypeId/" + serviceId + "/" + RateListId + "/" + RateTypeId +'/'+this.authservice.Loggeduser.specialityId)
  }
  get_typelist() {
    return this.http.get<any>(this.newbaseUrl + "BillTypeMaster/GetBillTypes")
  }
  get_Bill_Congigrationlist(BranchId: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetBillingConfigSetup/" + BranchId);

  }

  get_Update_OPDVisit(regId: any, apptId: any) {

    return this.http.get<any>(this.newbaseUrl + "Billing/UpdateAppointmentByRegIdApptId/" + regId + "/" + apptId);

  }
  addbillingdata(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Billing/InsertBill", data)
  }

  
  addvisitorData(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Billing/InsertOPDVisit", data)
  }

  getbillSummery(id) {
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetBills/" + id  + '/' + this.authservice.Loggeduser.specialityId)
  }
  addrecipts(data: any) {

    return this.http.post<any>(this.newbaseUrl + "Receipt/InsertReceiptMaster", data)
  }
  addbilingrecipts(data: any) {

    return this.http.post<any>(this.newbaseUrl + "ReceiptBilling/InsertReceiptMaster", data)
  }
  get_Bill_billId(BillId: number) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetBillByBillId/" + BillId);

  }

  get_service_byID(BillId: number) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetBillDetailByBillId/" + BillId);

  }


  getpaymentType() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetPaymenttype");

  }

  getdepositeType() {
    return this.http.get<any>(this.newbaseUrl + "Common/Getdeposittype");

  }
  getbankType() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetBank");

  }
  getbillingrecipt(pId: any, bId: any, flag: any) {
    return this.http.get<any>(this.newbaseUrl + "ReceiptBilling/GetReceiptMasterByRegIdBillId/" + pId + '/' + bId + '/' + flag)
  }
  getrecipt(pId: any, bId: any, flag: any) {
    return this.http.get<any>(this.newbaseUrl + "receipt/GetReceiptMasterByRegIdBillId/" + pId + '/' + bId + '/' + flag)
  }

  getallbills(sdate: string, edate: string, branchid: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetBillDateWise/?Fromdate=" +
      sdate + "&Todate=" + edate + "&BranchID=" + branchid + "&SpecialityIdModule=" + this.authservice.Loggeduser.specialityId)
  }

  getSpeciltiyData(specid) {
    return this.http.get(this.newbaseUrl + "Common/GetSubSpeciality/" + specid + '/' + this.authservice.Loggeduser.specialityId );
  }
  getbillHistory(pId: any, bId: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetBillHistoryByBillIdByRegId/" + bId + '/' + pId + '/' + this.authservice.Loggeduser.specialityId)
  }

  getInvestigationdata(pID: number) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetInvestigationDetailByRegId/" + pID + '/' + this.authservice.Loggeduser.specialityId);

  }

  // get_app_Congigrationlist(BranchId: any) {
  //   return this.http.get<any>(this.newbaseUrl + "Billing/GetBillingConfigSetup/" + BranchId);

  // }

  get_visitors_refound(billId: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetRefundAmountByBillId/" + billId);

  }

  addRefundDetails(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Receipt/InsertReceiptRefundDetail", data)
  }
  addRebillfundDetails(data: any) {
    return this.http.post<any>(this.newbaseUrl + "ReceiptBilling/InsertReceiptRefundDetail", data)
  }


  getRefounofReciept(billId: any) {
    return this.http.get<any>(this.newbaseUrl + "receipt/GetReceiptRefundDetailByReceiptId/" + billId);

  }
  getAdjustedbillsbyReciept(recieptId: any) {
    return this.http.get<any>(this.newbaseUrl + "Receipt/GetReceiptAdjustmentDetailByReceiptId/" + recieptId);

  }
  adjustbill(data: any) {

    return this.http.post<any>(this.newbaseUrl + "Receipt/UpdateAdjustedBillsByReceiptIdBillId", data)
  }

  addbillingmodificatins(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Billing/InsertBillModification", data)
  }
  savebillcancel(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Billing/CancelBill", data)

  }
  getbillingResionHelplist() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetPopUpHelpGeneral/BillingRemark")
  }

  getproductionConfrigration(branchid: any) {
    return this.http.get<any>(this.newbaseUrl + "Common/GetApplicationSetting/" + branchid);

  }


  getserviceByDepartmentId(DepId: any, CategoryId: any, RateListId: any, RateTypeId: any) {

    return this.http.get<any>(this.newbaseUrl + "RateList/GetRateListByDeptIdByCategoryIdRateListIdRateTypeId/" + DepId + "/" + CategoryId + "/" + RateListId + "/" + RateTypeId +'/'+this.authservice.Loggeduser.specialityId)
  }
  getserviceByDepartmentIdByCatByService(RateListId: any, RateTypeId: any, DepId: any, CategoryId: any, serviceId: any, searchtype: any) {

    return this.http.get<any>(this.newbaseUrl + "RateList/GetRateListByRateListIdRateTypeIdByDeptNameByCategoryNameByServiceName/" + RateListId + "/" + RateTypeId + "/" + DepId + "/" + CategoryId + "/" + serviceId + '/' + searchtype);
  }

  addPartialAmount(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Receipt/InsertReceiptAdjustmentDetail/", data)
  }

  getbillingScreenPermission(userid) {
    return this.http.get<any>(this.newbaseUrl + "UserMaster/GetUserScreenpermissionByUserId");
  //  return this.http.get<any>(this.newbaseUrl + "common/GetUserScreenpermission/" + userid);
    // return http://20.193.244.164/WebNetramAPIRajendra/api/common/GetUserScreenpermission/1
  }

  getallUsers() {
    return this.http.get<any>(this.newbaseUrl + "UserMaster/GetUserAll");
    // return http://20.193.244.164/WebNetramAPIRajendra/api/common/GetUserScreenpermission/1
  }
  getiolDetail(type) {
    return this.http.get(this.newbaseUrl + "Common/GetNameByType/"+type);
  }
  getDepartmentList() {
    return this.http.get<any>(this.newbaseUrl + "RateList/GetRateListDeptName/"+this.authservice.Loggeduser.specialityId);
  }

  getCateogryList(deptid) {
    return this.http.get<any>(this.newbaseUrl + "RateList/GetRateListCategoryByDeptId/" + deptid);
  }
  getAdustedDetails(RecieptId?: number, BillId?: number) {
    return this.http.get<any>(this.newbaseUrl + "receipt/GetReceiptAdjustmentDetailByReceiptIdByBillId/" + RecieptId + '/' + BillId);
  }

  getAdvanceReciept(PId) {
    return this.http.get<any>(this.newbaseUrl + "receipt/GetReceiptMasterByRegId/" + PId);
  }
  getVisitColorById(PId) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetBillingVisitColorByRegId/" + PId);
  }
  addreferalName(data: any) {
    return this.http.post<any>(this.newbaseUrl + "PersonMaster/InsertPersonMasterShort", data)
  }
  getDiscountReason() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetPopUpHelp/DiscountReason");
  }
  getIpChargeByID(IPDId) {
    return this.http.get<any>(this.newbaseUrl + "IPD/GetNursingChargesByIPDId/" + IPDId);
  }
  GetpackagebyIpdId(IPDId) {
    return this.http.get<any>(this.newbaseUrl + "IPD/GetPackageDetailWithServicesByIPDId/" + IPDId);
  }
  GetpackageMaster() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetServiceMaster");
  }
  GetservicebyPackageId(packageid: any) {
    return this.http.get<any>(this.newbaseUrl + "IPD/GetPackageDetailWithServicesByPackageId/" + packageid);
  }

  GetPartyByPartyId(partyid: any) {
    return this.http.get<any>(this.newbaseUrl + "PartyMaster/GetPartyByPartyId/" + partyid);
  }
  GetIpdRegListByRegId(patientid: any) {
    return this.http.get<any>(this.newbaseUrl + "IPD/GetIpdRegListByRegId/" + patientid +'/'+this.authservice.Loggeduser.specialityId);
  }
  InsertPartyCompany(partycompanyarray: any) {
    return this.http.post<any>(this.newbaseUrl + "Corporate/PartyDetailInsert", partycompanyarray);
  }
  GetPartyDetailByBIllId(billid: any, ipdId: any, fk_regid: any, counid: any) {
    //  return this.http.get<any>(this.newbaseUrl+"corporate/GetPartyDetailByPartyId/"+partydetailid);
    return this.http.get<any>(this.newbaseUrl + "Corporate/GetPartyDetailByBillId/" + billid + "/" + ipdId + "/" + fk_regid + '/' + counid);
  }
  GetCurrentStatus() {
    return this.http.get<any>(this.newbaseUrl + "Corporate/GetPartyStatus");
  }
  GetInsuranceCompany() {
    return this.http.get<any>(this.newbaseUrl + "Corporate/GetInsuranceCompany");
  }

  GetCouriorDetail(regId: any) {
    return this.http.get<any>(this.newbaseUrl + "Corporate/GetCourierDetailByRegId/" + regId);
  }

  InsertCouriorDetail(CouriorDetail: any) {
    return this.http.post<any>(this.newbaseUrl + "Corporate/InsertCourierDetail", CouriorDetail);
  }
  AddInsuranceComapny(ComapnyDetail: any) {
    return this.http.post<any>(this.newbaseUrl + "Corporate/InsertInsuranceCoMaster", ComapnyDetail);
  }
  GetChecklist(partyid: any) {
    return this.http.get<any>(this.newbaseUrl + "Corporate/GetPartyChecklistByPartyId/" + partyid);
  }

  DeleteIpdPackageDetailByIPDId(ipdid: any) {
    return this.http.get<any>(this.newbaseUrl + "IPD/DeleteIpdPackageDetailByIPDId/" + ipdid);
  }

  InsertIpdPackageDetail(packageDetail: any) {
    return this.http.post<any>(this.newbaseUrl + "IPD/InsertIpdPackageDetail", packageDetail);
  }

  getBillRefundList(flag: any, billid: any) {
    return this.http.get<any>(this.newbaseUrl + "Receipt/GetReceiptRefundDetailByReceiptIdByBillId/" + flag + '/' + billid)
  }
  GetRecoveryManagerFromDateToDateByPartyId(sdate: any, edate: any, partyid: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetRecoveryManagerFromDateToDateByPartyId/" + sdate + '/' + edate + '/' + partyid);
  }

  StoreRecoveryData(recvoryArray: any) {
    return this.http.post<any>(this.newbaseUrl + "Billing/InsertRecoveryManager", recvoryArray);

  }

  StoreRecoveryMasterData(recvoryobj: any) {
    return this.http.post<any>(this.newbaseUrl + "Billing/InsertRecoveryManagerMaster", recvoryobj);

  }
  GetRecoveryManagerByPartyIdByRegIdByBillIdByClaimNo(PartyId: any, RegId: any, BillId: any, ClaimNo: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetRecoveryManagerByPartyIdByRegIdByBillIdByClaimNo/" + PartyId + '/' + RegId + '/' + BillId + '/' + ClaimNo);

  }
  GetRecoveryManagerExcelSheetCheck(BranchId: any, FinYearId: any, BillSeriesId: any, BillNo: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetRecoveryManagerByBranchIdByFinYearIdByBillSeriesIdByBillNo/" + BranchId + '/' + FinYearId + '/' + BillSeriesId + '/' + BillNo);

  }

  GetRecoveryManagerByInsuranceCOmpanyId(BranchId: any, FinYearId: any, nsuranceCompanyId: any, BillSeriesId: any, BillNo: any, BillRefId: any, ClaimNo: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetRecoveryManagerByBranchIdByFinYearIdByInsuranceCompanyIdByBillSeriesIdByBillNoByBillRefIdByClaimNo/" + BranchId + '/' + FinYearId + '/' + nsuranceCompanyId + '/' + BillSeriesId + '/' + BillNo + '/' + BillRefId + '/' + ClaimNo);

  }
  GetRecoveryManagerByPartyTpaId(BranchId: any, FinYearId: any, PartyId: any, BillSeriesId: any, BillNo: any, BillRefId: any, ClaimNo: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetRecoveryManagerByBranchIdByFinYearIdByPartyIdByBillSeriesIdByBillNoByBillRefIdByClaimNo/" + BranchId + '/' + FinYearId + '/' + PartyId + '/' + BillSeriesId + '/' + BillNo + '/' + BillRefId + '/' + ClaimNo);

  }
  GetRecoveryRegisterrecord(FromDate: any, ToDate: any, InsuranceCompanyId: any, ClrBankId: any, ReferenceNo: any, ChequeTranNo: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetRecoveryRegisterByFromDateToDateByInsuranceCompanyIdByClrBankIdByReferenceNoByChequeTranNo/" + FromDate + '/' + ToDate + '/' + InsuranceCompanyId + '/' + ClrBankId + '/' + ReferenceNo + '/' + ChequeTranNo);

  }
  GetRecoveryData(recoveryid: any) {
    return this.http.get<any>(this.newbaseUrl + "Billing/GetRecoveryRegisterDetailByRecoveryId/" + recoveryid);

  }

  getPatientDoc(patientid: any, branchid: any, foldername: string) {
    return this.http.get<any>(this.newbaseUrl + "Document/GetAllFiles/" + patientid + '/' + branchid + '/' + foldername)
  }

  getIpdDoc(ipdid: any, branchid: any, foldername: string) {
    return this.http.get<any>(this.newbaseUrl + "Document/GetAllFiles/" + ipdid + '/' + branchid + '/' + foldername)
  }

  sendEmail(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Email/Send", data)
  }

  getAllEmailConfig() {
    return this.http.get<any>(this.newbaseUrl + "Email/ConfigEmail/0")
  }
  insertBillSelectBillSummary(billarray) {
    return this.http.post<any>(this.newbaseUrl + "Billing/InsertBillSelectBillSummary", billarray);
  }
  getappointment(Date: any, BranchId: any) {
    return this.http.get<any>(this.newbaseUrl + "OpdAppointment/DayWiseApp/" + Date + "/" + BranchId +'/'+this.authservice.Loggeduser.specialityId);

  }
  getSpeciltiyDatabyuserid(userid) {
    return this.http.get(this.newbaseUrl + "Common/GetSubSpecialityByUserId/" + userid +'/'+this.authservice.Loggeduser.specialityId);
  }
  getall_doctorsbysubspecilityId(specId) {
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetUserListBySubSpecialityId/6"
      + "/" + this.authservice.Loggeduser.branchid + "/" + this.selecteddate + "/6/" + specId +'/'+this.authservice.Loggeduser.specialityId);
  }
  getDrEmrServices(rateTypeId, RateListId, RegId, VisitDate) {
    return this.http.get(this.newbaseUrl + "Billing/GetInvestigationsDetailFromDoctorByRateTypeIdByRateListIdByRegIdByVisitDate/" + rateTypeId + '/' + RateListId + '/' + RegId + '/' + VisitDate +'/'+this.authservice.Loggeduser.specialityId);
  }
  insertBillingApproval(payload) {
    return this.http.post<any>(this.newbaseUrl + "Billing/InsertBillingApprovalDetail", payload);
  }
  getRequestStatusdata(BranchId, FromDate, ToDate, TypeBy, Status, billid) {
    return this.http.get(this.newbaseUrl + "Billing/GetApprovalDetailsByBranchIdFromDateToDateByTypeByStatusByBillID/" + BranchId + '/' + FromDate + '/' + ToDate + '/' + TypeBy + '/' + Status + '/' + billid);

  }
  updateBillingApproval(payload) {
    return this.http.post<any>(this.newbaseUrl + "Billing/UpdateBillingApprovalDetail", payload);
  }
  getUsertypemenuPermission(usertypeid:any,userid:any) {
    return this.http.get<any>(this.newbaseUrl + "Common/GetUserAuthTypeMenuPermissionDetailByAuthTypeIdById/" + usertypeid + "/" + this.authservice.pklanguageid +"/"+userid);
  }
  getlastvisitwith(patientid, doctorid, categoryid) {
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetLastPaidOPDBillsByRegIdByDoctorIdByCategoryId/" + patientid + '/' + doctorid + '/' + categoryid);

  }
  GetApprovalUser(type:any) {
    return this.http.get<any>(this.newbaseUrl + "Common/GetApprovalUser/" + type);

  }

  getBillFilter(data) {
    return this.http.post<any>(this.newbaseUrl + "Billing/GetBill", data);
  }
  getBrachMaster() {
    return this.http.get<any>(this.newbaseUrl + "BranchMaster/GetBranch/" + 0)
  }
 // Common/GetApprovalUser/BILLING
 GetBalanceAmountByRegId(pid:any){
  return this.http.get<any>(this.newbaseUrl + "ReceiptBilling/GetBalanceAmountByRegId/" + pid);
 
 }
}
